import React, { useState, useEffect } from "react";
import { List, Row, Col } from "antd";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var PrescriptionList = function PrescriptionList(_ref) {
  var data = _ref.data;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("div", {
      style: {
        textAlign: "center",
        marginBottom: "30px"
      }
    }), /*#__PURE__*/_jsx(List, {
      dataSource: data,
      renderItem: function renderItem(item) {
        return /*#__PURE__*/_jsx(List.Item, {
          children: /*#__PURE__*/_jsx(List.Item.Meta, {
            title: /*#__PURE__*/_jsxs("b", {
              children: [item.position.toString(), " / ", item.label, " ................................................................... Qte: ", item.quantity]
            }),
            description: /*#__PURE__*/_jsx("span", {
              style: {
                color: '#E96479'
              },
              children: item.comment
            })
          })
        });
      }
    })]
  });
};
export default PrescriptionList;